// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type StructuredLogsForMerlinSourceEventQueryVariables = Types.Exact<{
  sourceEventId: Types.Scalars['ID'];
  offset?: Types.Maybe<Types.Scalars['Int']>;
}>;


export type StructuredLogsForMerlinSourceEventQuery = (
  { __typename?: 'Query' }
  & { structuredLogsForMerlinSourceEvent?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'StructuredLog' }
    & Pick<Types.StructuredLog, 'id' | 'message' | 'code' | 'type' | 'filePath' | 'docsUrl' | 'errorUrl' | 'context' | 'level'>
    & { location?: Types.Maybe<(
      { __typename?: 'SourceCodeLocation' }
      & { start?: Types.Maybe<(
        { __typename?: 'SourceCodePosition' }
        & Pick<Types.SourceCodePosition, 'column' | 'line'>
      )> }
    )>, activity?: Types.Maybe<(
      { __typename?: 'BuildActivity' }
      & Pick<Types.BuildActivity, 'id' | 'name' | 'type' | 'message' | 'status' | 'statusText' | 'duration' | 'current' | 'total'>
    )> }
  )>>> }
);


export const StructuredLogsForMerlinSourceEventDocument = gql`
    query StructuredLogsForMerlinSourceEvent($sourceEventId: ID!, $offset: Int) {
  structuredLogsForMerlinSourceEvent(
    sourceEventId: $sourceEventId
    offset: $offset
  ) {
    id
    message
    code
    type
    filePath
    docsUrl
    errorUrl
    context
    level
    location {
      start {
        column
        line
      }
    }
    activity {
      id
      name
      type
      message
      status
      statusText
      duration
      current
      total
    }
  }
}
    `;

/**
 * __useStructuredLogsForMerlinSourceEventQuery__
 *
 * To run a query within a React component, call `useStructuredLogsForMerlinSourceEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructuredLogsForMerlinSourceEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructuredLogsForMerlinSourceEventQuery({
 *   variables: {
 *      sourceEventId: // value for 'sourceEventId'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useStructuredLogsForMerlinSourceEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StructuredLogsForMerlinSourceEventQuery, StructuredLogsForMerlinSourceEventQueryVariables>) {
        return ApolloReactHooks.useQuery<StructuredLogsForMerlinSourceEventQuery, StructuredLogsForMerlinSourceEventQueryVariables>(StructuredLogsForMerlinSourceEventDocument, baseOptions);
      }
export function useStructuredLogsForMerlinSourceEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StructuredLogsForMerlinSourceEventQuery, StructuredLogsForMerlinSourceEventQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StructuredLogsForMerlinSourceEventQuery, StructuredLogsForMerlinSourceEventQueryVariables>(StructuredLogsForMerlinSourceEventDocument, baseOptions);
        }
export type StructuredLogsForMerlinSourceEventQueryHookResult = ReturnType<typeof useStructuredLogsForMerlinSourceEventQuery>;
export type StructuredLogsForMerlinSourceEventLazyQueryHookResult = ReturnType<typeof useStructuredLogsForMerlinSourceEventLazyQuery>;
export type StructuredLogsForMerlinSourceEventQueryResult = ApolloReactCommon.QueryResult<StructuredLogsForMerlinSourceEventQuery, StructuredLogsForMerlinSourceEventQueryVariables>;
